import request from '@core/services/request';

export const routeOneAPI = {
	// Most of these endpoints will be moved to finanaceChannels over time.
	getLenders: () => request.get(`/RouteOne/GetLenders`),
	sendCreditApp: (fimenu: any, lender: any) => request.post(`/RouteOne/SendCreditApp`, { fimenu, lender }),
	getLatestCreditAppFieldsResponse: (storeCode: any) => request.get(`/RouteOne/GetLatestCreditAppFieldsResponse?storeCode=${storeCode}`),
	getLatestRouteOneCreditDecision: (conversationId: any) => request.get(`/RouteOne/CreditDecision/${conversationId}`),
	getCreditDecisionsForCreditApps: (conversationIds: any) => request.post(`/RouteOne/GetCreditDecisionsForCreditApps`, conversationIds),
	getAllCreditDecisionsForCreditApp: (conversationId: any, lenderCode: any = null) => {
		const url = lenderCode
			? `/RouteOne/GetCreditDecisionsForCreditApp/${conversationId}?r1LenderCode=${lenderCode}`
			: `/RouteOne/GetCreditDecisionsForCreditApp/${conversationId}`;

		return request.get(url);
	},
	getPayoffQuote: (poqRequest: any, config: any) => request.post(`/RouteOne/GetPayoffQuote`, poqRequest, config),
	getQuotes: (id: any) => request.get(`/RouteOne/GetQuotes?id=${id}`),
	getAllDocuments: (dealjacketId: any, storeCode: any) => request.get(`/RouteOne/GetAllDocuments?dealJacketId=${dealjacketId}&storeCode=${storeCode}`),
	createEContract: (creditApp: any, storeCode: any) => request.post(`/RouteOne/CreateEContract?storeCode=${storeCode}`, creditApp),
	generateEContract: (storeCode: any, dealJacketId: any) => request.get(`/RouteOne/GenerateEContract?storeCode=${storeCode}&dealJacketId=${dealJacketId}`),
	updateEContract: (storeCode: any, dealJacketId: any) => request.get(`/RouteOne/UpdateEContract?storeCode=${storeCode}&dealJacketId=${dealJacketId}`),
	validateEContract: (storeCode: any, dealJacketId: any, contractDate: any) =>
		request.get(`/RouteOne/ValidateEContract?storeCode=${storeCode}&dealJacketId=${dealJacketId}&contractDate=${contractDate}`),
	createDealJacketFromCustomer: (reqObj: any) => request.post('/RouteOne/CreateDealJacketFromCustomer', reqObj),
	updateDealJacket: (fimenu: any) => request.post('/RouteOne/UpdateCreditApp', fimenu),
	getDealJacketJSON: (id: any, transactionId?: string) => {
		let url = `/RouteOne/GetDealJacketJSON?id=${id}`;
		if (transactionId) {
			url += `&transactionId=${transactionId}`;
		}
		return request.get(url);
	},
	deleteEContract: (dealJacketId: any, storeCode: any) => request.post(`/RouteOne/DeleteEContract?storeCode=${storeCode}&dealJacketId=${dealJacketId}`),
	getLendersForAllStores: () =>
		request.get('/RouteOne/GetLendersForAllStores', {
			responseType: 'arraybuffer',
			headers: {
				Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			},
		}),
	getPayoffQuoteLenderCodes: (dealId: any, storeCode: any, lenderCode: any, dk: any) =>
		request.get(`/RouteOne/GetPOQLenderCodes?storeCode=${storeCode}&dealId=${dealId}&lenderCode=${lenderCode}&dk=${dk}`),
};
